import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer'; // CORRECTED: This should be './Footer'
import { IoMoon, IoSunny } from 'react-icons/io5';

const Layout = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(
    () => localStorage.getItem('theme') === 'dark'
  );
  
  const location = useLocation();
  const [bgImage, setBgImage] = useState('/images/home.png'); // Default to home.png

  useEffect(() => {
    const path = location.pathname;
    if (path === '/') {
      setBgImage('/images/home.png');
    } else if (path === '/login' || path === '/register') {
      setBgImage('/images/auth.png');
    } else if (path === '/dashboard' || path.startsWith('/tree/')) {
      setBgImage('/images/dashboard.png');
    } else if (path === '/stats') {
      setBgImage('/images/stats.png');
    }
  }, [location]);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  return (
    <div className={`min-h-screen flex flex-col font-sans relative ${isDarkMode ? 'dark bg-gray-900' : 'bg-brand-white'}`}>
      
      {/* Dynamic Background Layer - Opacity set to 40 */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-80 transition-all duration-700 ease-in-out" 
        style={{ backgroundImage: `url('${bgImage}')` }}
      />
      
      {/* Content Layer */}
      <div className="relative z-10 min-h-screen flex flex-col">
        <Navbar />

        <button 
          onClick={() => setIsDarkMode(!isDarkMode)} 
          className="fixed bottom-4 right-4 z-50 p-3 rounded-full shadow-xl bg-brand-green-dark text-white hover:bg-brand-green transition-colors"
        >
          {isDarkMode ? <IoSunny size={20} /> : <IoMoon size={20} />}
        </button>

        <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;